import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedHome = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="home" size="100%" color={stroke ?? color} />
);

export { LineRoundedHome };
